var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('div',{staticClass:"mb-2 font-weight-bold"},[_vm._v("Tặng quà")]),_c('custom-buy-x-get-y',{attrs:{"isGiftSection":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }